import RefreshIcon from "@mui/icons-material/Refresh";
import { Box, Tooltip, Typography } from "@mui/material";
import { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { ReactComponent as CreateIcon } from "../../assets/USA_Images/CreateIcon.svg";
import DataTableLatest from "../../components/DataTable/DataTableLatest";
import EditIcon from "../../Pages/Person/EditIcon";
import { getAllZone } from "../../slices/Zone/ZoneSlice";
import { ThemeContext } from "../../theme/ThemeContext";
import FilterChecklistTemplate from "../ChecklistTemplateUSA/FilterChecklistTemplate";
import DeleteIcon from "../Watchlist/DeleteIcon";
import AddZone from "./AddZone";
import DeleteZone from "./DeleteZone";
import ZoneView from "./ZoneView";

function ZoneList() {
  const [rows, setRows] = useState([]);
  const dispatch = useDispatch();
  const [openEditDialog, setOpenEditDialog] = useState(false);
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(50);
  const [totalPages, setTotalPages] = useState(0);
  const [totalRecords, setTotalRecords] = useState(1);
  const [clear, setClear] = useState(false);
  const [searchedRows, setSerchedRows] = useState([]);
  const [open, setOpen] = useState(false);
  const [openDeleteZone, setOpenDeletZone] = useState(false);
  const [zoneId, setZoneId] = useState();
  const [del, setDel] = useState(false);
  const [pageSize, setPageSize] = useState(0);
  const { t } = useTranslation();
  const { darkMode, setDiaLogBoxBlur } = useContext(ThemeContext);
  const [paging, setPaging] = useState({
    page: 1,
    rowsPerPage: 50,
  });
  const [filter, setFilter] = useState({
    name: "",
  });

  const [selectedObject, setSelectedObject] = useState({
    zoneId: "",
    name: "",
    siteId: "",
  });

  const defaultFilter = {
    name: "",
  };

  const handleChange = (newPage, size) => {
    setRowsPerPage(size);
    setPage(newPage);
    setPaging({
      page: newPage,
      rowsPerPage: size,
    });
  };

  useEffect(() => {
    loadData(filter, paging);
  }, [filter, paging, clear]);

  const handleOpen = () => {
    setOpenEditDialog(true);
    setDiaLogBoxBlur(true);
  };

  const resetFilter = () => {
    setClear(false);
    setPaging({ ...paging, page: 1 });
    setFilter(defaultFilter);
  };

  const loadData = (filter, paging) => {
    dispatch(getAllZone(Object.assign(filter, paging)))
      .unwrap()
      .then((data) => {
        if (data.code === "LMSI0000" && data.data) {
          setRows(data.data.zone);
          setPage(data.data.currentPage);
          setTotalPages(data.data.totalPages);
          setPageSize(data.data.pageSize);
          setTotalRecords(data.data.totalCount);
        } else {
          setRows([]);
        }
      })
      .catch((er) => { });
  };

  function handleTextOverflow(text) {
    if (text && text.length > 20) {
      return text.substring(0, 20) + "...";
    } else {
      return text;
    }
  }

  const handleClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    if (del === true && parseInt(pageSize) !== 1) {
      loadData({ page: page, rowsPerPage: rowsPerPage }, filter);
      setDel(false);
    } else {
      if (del === true) {
        setPaging({ page: page - 1, rowsPerPage: rowsPerPage });
        setDel(false);
      }
    }
  }, [del]);

  const handleEditVisit = (params) => {
    setOpenEditDialog(!openEditDialog);
    setSelectedObject(params);
    setDiaLogBoxBlur(true);
  };

  const handleDeleteZone = (params) => {
    setOpenDeletZone(!openDeleteZone);
    setZoneId(params.id);
    setDiaLogBoxBlur(true);
  };

  const handleFilter = (data) => {
    setClear(true);
    setPaging({ ...paging, page: 1 });
    setFilter({
      name: data.name,
    });
  };

  const columns = [
    {
      headerName: "",
      sortable: false,
      width: 5,
      renderCell: (params) => {
        return <div></div>;
      },
    },

    {
      field: "zoneName",
      headerName: t("COMMON143"),
      flex: 1,
      width: 180,
      valueGetter: (params) => params.row.zoneName,
      renderCell: (params) => (
        <Tooltip title={` ${params.row.zoneName}`} placement="bottom-start">
          <span>{handleTextOverflow(params.row.zoneName)}</span>
        </Tooltip>
      ),
    },

    {
      field: "siteName",
      headerName: t("COMMON144"),
      flex: 1,
      width: 180,
      valueGetter: (params) => params.row.siteName,
      renderCell: (params) => (
        <Tooltip title={` ${params.row.siteName}`} placement="bottom-start">
          <span>{handleTextOverflow(params.row.siteName)}</span>
        </Tooltip>
      ),
    },

    {
      field: "addressLine1",
      headerName: t("ADD012"),
      flex: 0,
      width: 180,
      valueGetter: (params) => params.row.addressLine1,
      renderCell: (params) => (
        <Tooltip title={` ${params.row.addressLine1}`} placement="bottom-start">
          <span>{handleTextOverflow(params.row.addressLine1)}</span>
        </Tooltip>
      ),
    },
    {
      field: "Actions",
      headerName: t("ACTION"),
      type: "actions",
      flex: 1,
      width: 180,
      headerAlign: "center",

      getActions: (params) => [
        <ZoneView title={t("ADD034")} rowData={params.row} />,
        <Box onClick={() => handleEditVisit(params.row)}>
          <EditIcon />
        </Box>,
        <Box onClick={() => handleDeleteZone(params)}>
          <DeleteIcon />
        </Box>,
      ],
    },
  ];

  useEffect(() => {
    if (darkMode) {
      document.body.classList.add("darkMode");
    } else {
      document.body.classList.remove("darkMode");
    }
    return () => {
      document.body.classList.remove("darkMode");
    };
  }, [darkMode]);

  return (
    <>
      <Box>
        <Typography variant="h3" style={{ color: darkMode ? "#ffff" : "" }}>
          {t("COMMON022")}
        </Typography>
      </Box>
      <Box style={{
        display: "flex",
        flexDirection: "row-reverse",
        justifyContent: "flex-start",
        alignItems: "center",
        gap: "3px"
      }}>
        <Box item>
          {clear && (
            <Link
              href="#"
              underline="hover"
              className="line"
              style={{
                opacity: "1",
                color: "#E3393C",
                fontSize: "14px",
                underline: "hover",
                display: "inline",
              }}
              onClick={resetFilter}
            >
              {"Clear Filter"}
            </Link>
          )}
        </Box>
        <Tooltip title={t("COMMON145")}>
          <Box item className={"addIcon"}
            onClick={handleOpen}>
            <CreateIcon />
          </Box>
        </Tooltip>
        <Tooltip title={t("COMMON002")}>
          <Box item className="refreshIcon">
            <RefreshIcon onClick={() => loadData(filter, paging)} />
          </Box>
        </Tooltip>
        <Box item>
          <FilterChecklistTemplate
            rowsPerPage={rowsPerPage}
            applyFilter={(data) => handleFilter(data)}
          />
        </Box>
      </Box>

      <div style={{ height: 300, width: "100%", paddingTop: "10px" }}>
        <DataTableLatest
          columns={columns}
          rows={searchedRows.length === 0 ? rows : searchedRows}
          page={page}
          pageCount={totalPages}
          pageSize={rowsPerPage}
          count={totalRecords}
          handleChange={(newPage, size) => handleChange(newPage, size)}
        />
      </div>

      {open && (
        <AddZone
          selectedObject={selectedObject}
          open={open}
          handleClose={() => {
            setOpen(false);
            loadData(filter, paging);
          }}
        />
      )}

      {openEditDialog && (
        <AddZone
          selectedObject={selectedObject}
          open={openEditDialog}
          handleClose={() => {
            setOpenEditDialog(false);
            loadData(filter, paging);
            setDiaLogBoxBlur(false);
            setSelectedObject({
              zoneId: "",
              name: "",
              siteId: "",
            });
          }}
        />
      )}

      {openDeleteZone && (
        <DeleteZone
          open={openDeleteZone}
          handleClose={(data) => {
            setOpenDeletZone(false);
            setDiaLogBoxBlur(false);
          }}
          delete={(a) => setDel(true)}
          DeleteId={zoneId}
        />
      )}
    </>
  );
}

export default ZoneList;
